const MASK_TOKENS = {
    "9": {
        test: /[0-9]/,
        format: (char) => char,
    },
    "a": {
        test: /[a-z]/i,
        format: (char) => char.toLowerCase(),
    },
    "A": {
        test: /[a-z]/i,
        format: (char) => char.toUpperCase(),
    },
    "*": {
        test: /[a-z0-9]/i,
        format: (char) => char,
    },
};

function getMaskTokenChars(mask) {
    return [...new Set([...mask].filter((char) => MASK_TOKENS[char]))];
}

function hasRemainingTokenChars(sourceChars, startIndex, tokenChars) {
    for (let index = startIndex; index < sourceChars.length; index += 1) {
        const char = sourceChars[index];

        if (tokenChars.some((tokenChar) => MASK_TOKENS[tokenChar].test.test(char))) {
            return true;
        }
    }

    return false;
}

function applyMask(value, mask) {
    const sourceChars = [...value];
    const tokenChars = getMaskTokenChars(mask);
    let sourceIndex = 0;
    let result = "";

    for (let maskIndex = 0; maskIndex < mask.length; maskIndex += 1) {
        const maskChar = mask[maskIndex];
        const token = MASK_TOKENS[maskChar];

        if (!token) {
            if (sourceChars[sourceIndex] === maskChar) {
                result += maskChar;
                sourceIndex += 1;
                continue;
            }

            if (hasRemainingTokenChars(sourceChars, sourceIndex, tokenChars)) {
                result += maskChar;
            }

            continue;
        }

        while (sourceIndex < sourceChars.length) {
            const sourceChar = sourceChars[sourceIndex];

            if (token.test.test(sourceChar)) {
                result += token.format(sourceChar);
                sourceIndex += 1;
                break;
            }

            const nextMaskChar = mask[maskIndex + 1];
            const nextIsLiteral = !!nextMaskChar && !MASK_TOKENS[nextMaskChar];

            // Keep later segments aligned when a token in the current segment is removed.
            if (nextIsLiteral && sourceChar === nextMaskChar) {
                break;
            }

            sourceIndex += 1;
        }
    }

    return result;
}

function maskInput(input) {
    const mask = input.dataset.mask;
    if (!mask) return;

    const maskedValue = applyMask(input.value, mask);

    if (input.value !== maskedValue) {
        input.value = maskedValue;
    }
}

function handleMaskingEvent(event) {
    const input = event.target;

    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches("[data-mask]")) return;

    maskInput(input);
}

export function initInputMasks(root = document) {
    root.addEventListener("input", handleMaskingEvent, true);
    root.addEventListener("change", handleMaskingEvent, true);
}